import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DefMM13Element } from '../../../masterdata/models/config-version/DefMM13Element';
import { MEASURE_CATEGORIZATION_KEY_PREFIX, MEASURE_CATEGORIZATION_KEY_SUFIX, MeasureCategorisation } from '../../models/criterions/MeasureCategorisation';
import { getMeasureStatusTranslationKey, Status } from '../../models/criterions/Status';
import { DataMM13ElementItem } from '../models/DataMM13ElementItem';
import { TranslationUtils } from 'src/app/shared/utils/translation-utils';

export class Cr13Utils {
    static getHazardDescriptionName(element: DefMM13Element | undefined, language: string): string {
        return element
            ? element.mainGroup?.toString() +
                  (element.subGroup ? '.' + element.subGroup : '') +
                  (element.hazardElement ? '.' + element.hazardElement : '') +
                  ' ' +
                  TranslationUtils.translateTextValue(element.name, language)
            : '';
    }

    static getMeasureStatusIconClass(measureStatus: Status): string {
        if (measureStatus) {
            switch (measureStatus) {
                case Status.OPEN:
                    return 'ci ci-door_open';
                case Status.IN_PROCESS:
                    return 'ci ci-loader';
                case Status.REALIZED:
                    return 'ci ci-check';
                case Status.REJECTED:
                    return 'ci ci-close';
                default:
                    return '';
            }
        } else {
            return '';
        }
    }

    static generateMeasureStatusKey(measureStatus: Status): string {
        return getMeasureStatusTranslationKey(measureStatus);
    }

    static generateMeasureCategorizationKey(measureCategorization: MeasureCategorisation) {
        return `${MEASURE_CATEGORIZATION_KEY_PREFIX}${measureCategorization}${MEASURE_CATEGORIZATION_KEY_SUFIX}`;
    }

    static riskMatrixSelectionValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const riskMatrixSelection = control.value;
            return riskMatrixSelection != null && (this.riskMatrixHasSelection(riskMatrixSelection) || this.riskMatrixNoRiskRemaining(riskMatrixSelection))
                ? null
                : { riskMatrixSelectionInvalid: true };
        };
    }

    private static riskMatrixHasSelection(riskMatrixSelection: any): boolean {
        return riskMatrixSelection.likelyhood && riskMatrixSelection.severity && riskMatrixSelection.color && riskMatrixSelection.rzValue > 0;
    }

    private static riskMatrixNoRiskRemaining(riskMatrixSelection: any): boolean {
        return riskMatrixSelection.rzValue !== null && riskMatrixSelection.rzValue === 0;
    }

    static getHazardIdentificationName(element: DataMM13ElementItem, translateService: TranslateService): string {
        if (element.heatIndexitem) {
            return translateService.instant('ENUM.SEARCH_RESULT_COLUMN.MM09') + ' - ' + translateService.instant('PAGE.MM_13.RISK_HEAT_INDEX.LBL');
        }
        if (element.windChillItem) {
            return translateService.instant('ENUM.SEARCH_RESULT_COLUMN.MM09') + ' - ' + translateService.instant('PAGE.MM_13.RISK_WINDCHILL_INDEX.LBL');
        }
        if (element.problem?.description === 'MM08') {
            return translateService.instant('ENUM.SEARCH_RESULT_COLUMN.MM08');
        }
        return element.problem?.description ? translateService.instant(element.problem.description) : '';
    }

    static sortCategoryValues(aValue: string | undefined, bValue: string | undefined, sortOrder: number): number {
        const aNumberBeforeDot = parseFloat(aValue?.split('.')[0] || '0');
        const bNumberBeforeDot = parseFloat(bValue?.split('.')[0] || '0');

        if (aNumberBeforeDot !== bNumberBeforeDot) {
            return sortOrder === 1 ? aNumberBeforeDot - bNumberBeforeDot : bNumberBeforeDot - aNumberBeforeDot;
        }

        return sortOrder === 1 ? (aValue || '').localeCompare(bValue || '') : (bValue || '').localeCompare(aValue || '');
    }
}
